"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.designTokens = void 0;
const Button_1 = require("../Button/desingTokens/Button");
const Global_1 = require("./tokens/Global");
const Dialog_1 = require("../Dialog/designTokens/Dialog");
const ProgressBar_1 = require("../ProgressBar/designTokens/ProgressBar");
const Tab_1 = require("../TabList/designTokens/Tab");
const TabList_1 = require("../TabList/designTokens/TabList");
exports.designTokens = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Button_1.buttonTokens), Dialog_1.dialogTokens), TabList_1.tabListTokens), Tab_1.tabTokens), ProgressBar_1.progressBarTokens), Global_1.globalTokens);
//# sourceMappingURL=designTokens.js.map